import React from 'react'
import styled from '@emotion/styled'
import { Step, StepProps } from '@mui/material'

import circlesOrbitColorPalette from '../../common/ui/circlesColorTheme'

const StyledMuiStep = styled(Step)({
  '&.MuiStep-horizontal .MuiStepLabel-root.MuiStepLabel-horizontal .Mui-active':
    {
      color: circlesOrbitColorPalette.accent.main //accent.main-fuschia
    },
  '&.MuiStep-horizontal .MuiStepLabel-root.MuiStepLabel-horizontal .Mui-completed':
    {
      color: circlesOrbitColorPalette.accent.main //accent.main-fuschia
    },
  '&.MuiStep-vertical .MuiStepLabel-root.MuiStepLabel-vertical .Mui-active': {
    color: circlesOrbitColorPalette.primary.main
  },
  '&.MuiStep-vertical .MuiStepLabel-root.MuiStepLabel-vertical .Mui-completed':
    {
      color: circlesOrbitColorPalette.primary.main
    }
})

const StyledStep = (props: StepProps) => {
  const { children, ...otherProps } = props
  return <StyledMuiStep {...otherProps}>{children}</StyledMuiStep>
}

export default StyledStep
